/**
 * Second Wind: the reload that matters is the one you do while losing.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const SECOND_WIND = {
  id: 'secondWind',
  branch: 'gunplay',
  tier: 3,
  title: 'Second Wind',
  blurb: 'Fatigue is largely psychological. So is most of the bleeding.',
  maxRanks: 2,
  minLevel: 17,
  requires: ['runningReload'],
  statGrants: {},
  effects: [{ field: 'reloadSeconds', perRank: -0.1, condition: 'whileHurt' }],
  damageModifiers: [],
} as const satisfies Perk;
